<template>
  <v-dialog v-model="dialog" max-width="60%">
    <template v-slot:activator="{ on }">
      <slot name="button" :on="on">
        <v-btn outlined rounded small v-on="on" color="primary">
          <v-icon left small>add</v-icon>
          New
        </v-btn>
      </slot>
    </template>
    <v-card>
      <v-card-title class="headline">
        <slot name="title">
          <div>Add New Incoming Material</div>
        </slot>
        <v-spacer />
        <v-btn icon @click="close"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-form v-model="$v.valid" @submit.prevent="submit">
          <v-text-field
            v-model.trim="$v.formdata.name.$model"
            :error-messages="nameErrors"
            label="Name of Incoming Material"
            counter="124"
            hint="Make the name easy to recognize for receiving team"
            @input="$v.formdata.name.$touch()"
            @blur="$v.formdata.name.$touch()"
          />
          <v-text-field
            v-model.trim="$v.formdata.notes.$model"
            :error-messages="notesErrors"
            label="Notes or Info Regarding Shipment"
            hint="i.e. This will arrive in barrels"
            counter="124"
            @input="$v.formdata.notes.$touch()"
            @blur="$v.formdata.notes.$touch()"
          />
          <v-text-field
            v-model.trim="$v.formdata.expected_quantity.$model"
            :error-messages="expectedquantityErrors"
            label="Expected Quantity"
            counter="28"
            @input="$v.formdata.expected_quantity.$touch()"
            @blur="$v.formdata.expected_quantity.$touch()"
          />
          <v-checkbox
            v-model="formdata.received"
            label="Material Received?"
          />
          <div class="body-2">
            Date That Material Was Received
          </div>
          <v-date-picker
            v-model="formdata.received_on"
            label="Received On"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="red" class="mx-1" @click="close">
          Close
        </v-btn>
        <v-btn
          text
          @click="submit"
          :disabled="$v.$invalid"
          color="success"
          class="mx-1"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ProjectMaterial from "../../models/ProjectMaterial";
import { handleErrors } from "../../services/formErrors";
import { validationMixin } from "vuelidate";
export default {
  name: "ProjectMaterialForm",
  mixins: [validationMixin],
  validations: ProjectMaterial.validations,
  props: {
    instance: {
      type: Object,
      required: false,
      default: () => {}
    },
    id: {
      type: [Number, String],
      required: true
    },
    isEdit: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      formdata: new ProjectMaterial(this.instance),
    };
  },
  computed: {
    nameErrors() {
      return handleErrors("formdata", "name", this);
    },
    notesErrors() {
      return handleErrors("formdata", "notes", this);
    },
    expectedquantityErrors() {
      return handleErrors("formdata", "expected_quantity", this);
    }
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.isEdit) {
        ProjectMaterial
          .$put(this.instance.id, this.formdata.toUpdatePayload())
          .then(() => this.close());
      } else {
        // tag the project ID
        this.formdata.project_id = this.id;
        // on successful submit clear and close the form
        ProjectMaterial
          .$post(this.formdata.toCreatePayload())
          .then(() => this.clear());
      }
    },
    close() {
      this.dialog = false;
    },
    open() {
      this.dialog = true;
    },
    clear() {
      this.formdata = new ProjectMaterial();
      this.$v.$reset();
      this.dialog = false;
    }
  }
}
</script>
